<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="skeleton__wrapper">
    <div class="container">
      <CiSkeletonItem class="mt-12 h-[130px] w-full lg:h-24" />
      <CiSkeletonItem class="mb-1 mt-12 h-6 w-1/2 lg:w-1/5" />
      <CiSkeletonItem class="h-36 w-full lg:h-12" />

      <div class="grid grid-cols-2 lg:gap-x-[30px]">
        <div class="col-span-2 mt-12 lg:col-span-1">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="skeleton__input--title mb-4 h-14" />

          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="mb-4 h-32" />

          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="mb-4 h-32" />

          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="mb-4 h-[60px]" />
        </div>
        <div class="col-span-2 mt-6 lg:col-span-1 lg:mt-12">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="h-[508px]" />
        </div>
      </div>

      <div class="mt-2 grid grid-cols-2 lg:gap-x-[30px]">
        <div class="col-span-2">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="h-[57px] w-full" />
        </div>

        <div class="col-span-2 mt-12 lg:col-span-1">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="h-[57px] w-full" />
        </div>

        <div class="col-span-2 mt-6 lg:col-span-1 lg:mt-12">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="h-[57px] w-full" />
        </div>
      </div>
    </div>
  </div>
</template>
